import { gameModes } from "@/shared/config/siteContent";
import { BoardFrame } from "@/shared/ui/BoardFrame";
import { SectionCard } from "@/shared/ui/SectionCard";
import { SectionIntro } from "@/shared/ui/SectionIntro";

export function GamesPage() {
  return (
    <div className="page-stack">
      <section className="hero-grid">
        <article className="hero-copy-panel">
          <p className="section-intro__eyebrow">Games</p>
          <h1 className="page-title">
            Mini-games belong in their own arena so the homepage remains
            imperial.
          </h1>
          <p className="page-copy">
            The games route should concentrate all high-variation modes in one
            curated hub: choose-move, human-versus-AI comparison, and guess the
            elo. Each mode needs distinct framing and a clear reward loop.
          </p>
          <div className="signal-strip">
            <span className="signal-tag">No homepage clutter</span>
            <span className="signal-tag">Streaks can become status</span>
            <span className="signal-tag">Replay and history matter</span>
          </div>
        </article>

        <BoardFrame
          title="Games command surface"
          status="contained chaos"
          accent="acid"
          eyebrow="Mini-game arena"
        />
      </section>

      <section className="section">
        <SectionIntro
          eyebrow="Modes"
          title="Each mode should feel like its own dramatic test, not just another card in a grid."
          description="The hub should help users choose a mode quickly while preserving the sense that each one has different stakes and different output history."
        />

        <div className="feature-grid">
          {gameModes.map((mode) => (
            <SectionCard key={mode.title} eyebrow={mode.eyebrow} title={mode.title}>
              <p>{mode.body}</p>
            </SectionCard>
          ))}
        </div>
      </section>
    </div>
  );
}
